import { Table, TableWrapper, Tbody, Td, Tr } from '@components/core-ui/Table';
import { DisclosureSection } from '@components/core-ui/DisclosureSection';

import { routes } from '@routes';
import { AdminGetOrganizationResponseDto } from 'app/API';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CellContent } from './styles/CellContent';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  workspaces: AdminGetOrganizationResponseDto['workspaces'];
};
export const WorkspacesTable = ({ workspaces }: TProps) => {
  const [workspacesDisclosureOpen, setWorkspacesDisclosureOpen] = useState<boolean>(true);

  const workspaceSectionTitle = `Workspaces${workspaces?.length > 0 ? ` (${workspaces?.length})` : ''}`;

  return (
    <Wrapper className="flex flex-col">
      <div>
        <DisclosureSection
          title={workspaceSectionTitle}
          open={workspacesDisclosureOpen}
          setOpenState={setWorkspacesDisclosureOpen}
          loading={false}
        >
          <TableWrapper>
            <Table>
              <Tbody>
                {workspaces.map((data) => (
                  <Tr key={data.id}>
                    <Td>
                      <CellContent style={{ width: '250px' }}>
                        <Link to={routes.adminWorkspaceDetails.make(data.id ?? '')} className="underline">
                          {data.name}
                        </Link>
                      </CellContent>
                    </Td>
                    <Td>
                      <CellContent>
                        {data.jobsProcessing !== undefined ? (
                          <span style={{ display: 'block' }}>{data.jobsProcessing} jobs processing</span>
                        ) : null}
                      </CellContent>
                    </Td>
                    <Td>
                      <CellContent>
                        {data.jobsReadyForTranscribing !== undefined ? (
                          <span style={{ display: 'block' }}>
                            {data.jobsReadyForTranscribing} jobs ready for editing
                          </span>
                        ) : null}
                      </CellContent>
                    </Td>
                    <Td style={{ width: '1%' }}>
                      <CellContent>
                        {data.jobsComplete !== undefined ? (
                          <span style={{ display: 'block' }}>{data.jobsComplete} completed jobs</span>
                        ) : null}
                      </CellContent>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableWrapper>
        </DisclosureSection>
      </div>
    </Wrapper>
  );
};
